import { UserProfile, Post, ShortVideo, LongVideo, MediaHistoryItem } from './types';

export const initialUserProfile: UserProfile = {
  name: 'Alex Morgan',
  username: 'alex_creator',
  email: 'alex.morgan@socialverse.io',
  phone: '+1 (555) 234-8901',
  address: '742 Evergreen Terrace, Creative District, CA 94107',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&auto=format&fit=crop&q=80',
  bio: 'Visual story designer & digital creator 🎬 Exploring travel, tech & cinematic design aesthetics.',
  website: 'https://alexmorgan.design',
  fansCount: 124800,
  followingCount: 412,
  totalLikes: 890500,
  totalDislikes: 42,
  totalViews: 2450000,
  totalUploads: 48
};

export const samplePosts: Post[] = [
  {
    id: 'post-1',
    authorName: 'Elena Rostova',
    authorUsername: 'elena_visuals',
    authorAvatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200&auto=format&fit=crop&q=80',
    isVerified: true,
    timeAgo: '2 hours ago',
    content: 'Golden hour lights over the coastal cliffs of Big Sur. Captured with 35mm f/1.4 lens. Minimal edits, pure atmosphere 🌊✨ What vibe do you feel here?',
    mediaUrl: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1000&auto=format&fit=crop&q=80',
    mediaType: 'image',
    likes: 14200,
    comments: 384,
    shares: 89,
    isLiked: false,
    isBookmarked: false,
    tags: ['photography', 'nature', 'travel', 'wanderlust']
  },
  {
    id: 'post-2',
    authorName: 'Kai Tanaka',
    authorUsername: 'kai_motion',
    authorAvatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&auto=format&fit=crop&q=80',
    isVerified: true,
    timeAgo: '5 hours ago',
    content: 'Neon reflections in Shinjuku after midnight rain. Tokyo always breathes with cinematic energy. Sound on for the ambient city buzz 🎧',
    mediaUrl: 'https://images.unsplash.com/photo-1503899036084-c55cdd92da26?w=1000&auto=format&fit=crop&q=80',
    mediaType: 'image',
    likes: 28900,
    comments: 612,
    shares: 430,
    isLiked: true,
    isBookmarked: true,
    tags: ['tokyo', 'cyberpunk', 'streetphotography', 'nightlife']
  },
  {
    id: 'post-3',
    authorName: 'Sora Architecture',
    authorUsername: 'sora_design',
    authorAvatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&auto=format&fit=crop&q=80',
    isVerified: false,
    timeAgo: '1 day ago',
    content: 'Simplicity is the ultimate sophistication. Exploring raw concrete geometry bathed in morning light. Thoughts on brutalist interior spaces?',
    mediaUrl: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1000&auto=format&fit=crop&q=80',
    mediaType: 'image',
    likes: 8520,
    comments: 194,
    shares: 67,
    isLiked: false,
    isBookmarked: false,
    tags: ['architecture', 'interiordesign', 'minimalism']
  }
];

export const sampleShorts: ShortVideo[] = [
  {
    id: 'short-1',
    authorName: 'Liam Carter',
    authorUsername: 'liam_explores',
    authorAvatar: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=200&auto=format&fit=crop&q=80',
    thumbnailUrl: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?w=800&auto=format&fit=crop&q=80',
    caption: 'Secret waterfall hidden in the alpine rainforest 🌲 Wait till the end! #nature #hiking #adventure',
    audioTrack: 'Original Sound - Ambient Forest Sounds',
    likes: 184500,
    comments: 2430,
    shares: 15200,
    isLiked: false,
    isBookmarked: false,
    isFollowing: false
  },
  {
    id: 'short-2',
    authorName: 'Zoe Tech Lab',
    authorUsername: 'zoe_devices',
    authorAvatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=200&auto=format&fit=crop&q=80',
    thumbnailUrl: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=800&auto=format&fit=crop&q=80',
    caption: 'Top 3 Android 15 gestures everyone should enable right now! 📱⚡ #android #techhacks #tips',
    audioTrack: 'Synthwave Beats - Chill Flow',
    likes: 312000,
    comments: 4890,
    shares: 38400,
    isLiked: true,
    isBookmarked: true,
    isFollowing: true
  },
  {
    id: 'short-3',
    authorName: 'Chef Mateo',
    authorUsername: 'mateo_bites',
    authorAvatar: 'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=200&auto=format&fit=crop&q=80',
    thumbnailUrl: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=800&auto=format&fit=crop&q=80',
    caption: '60-second artisanal ramen broth recipe. Deep umami flavor! 🍜🔥 #foodie #cooking #recipe',
    audioTrack: 'Lo-Fi Cooking Grooves - Studio M',
    likes: 98400,
    comments: 1120,
    shares: 8400,
    isLiked: false,
    isBookmarked: false,
    isFollowing: false
  }
];

export const sampleLongVideos: LongVideo[] = [
  {
    id: 'long-1',
    title: 'Designing The Perfect Mobile Experience: Complete UI/UX Masterclass',
    description: 'Learn foundational UI typography, spatial hierarchy, gesture navigation, and Android Material 3 design systems step by step with real prototyping techniques.',
    authorName: 'Design Code Academy',
    authorUsername: 'designcode',
    authorAvatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200&auto=format&fit=crop&q=80',
    thumbnailUrl: 'https://images.unsplash.com/photo-1581291518857-4e27b48ff24e?w=1200&auto=format&fit=crop&q=80',
    duration: '24:18',
    views: '482K views',
    uploadedAt: '3 days ago',
    followers: '1.2M followers',
    likes: 38400,
    isFollowing: true
  },
  {
    id: 'long-2',
    title: '4K Cinematic Drone Odyssey: Exploring Iceland Fjords & Glaciers',
    description: 'A 45-minute relaxation visual trip through black sand beaches, thundering waterfalls, and glacial lagoons captured in ProRes raw.',
    authorName: 'Earth Horizon Cinema',
    authorUsername: 'earthhorizon',
    authorAvatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&auto=format&fit=crop&q=80',
    thumbnailUrl: 'https://images.unsplash.com/photo-1504893524553-b855bce32c67?w=1200&auto=format&fit=crop&q=80',
    duration: '45:30',
    views: '1.8M views',
    uploadedAt: '2 weeks ago',
    followers: '890K followers',
    likes: 129000,
    isFollowing: false
  },
  {
    id: 'long-3',
    title: 'Full Stack Web Architecture in 2026: Fast, Scalable & Delightful',
    description: 'Deep dive into modern web deployment, responsive layouts, progressive web apps, and API best practices with practical real-world walk-throughs.',
    authorName: 'Tech Frontier',
    authorUsername: 'techfrontier',
    authorAvatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&auto=format&fit=crop&q=80',
    thumbnailUrl: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=1200&auto=format&fit=crop&q=80',
    duration: '32:05',
    views: '290K views',
    uploadedAt: '1 month ago',
    followers: '450K followers',
    likes: 21500,
    isFollowing: true
  }
];

export const initialMediaHistory: MediaHistoryItem[] = [
  {
    id: 'hist-1',
    title: 'Sunset over Santa Monica Pier [Vlog Clip]',
    type: 'video',
    mediaUrl: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&auto=format&fit=crop&q=80',
    thumbnailUrl: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=600&auto=format&fit=crop&q=80',
    uploadDate: 'Sep 02, 2026',
    views: 18400,
    likes: 1240,
    duration: '04:15',
    fileSize: '48.2 MB',
    tags: ['vlog', 'sunset', 'beach', 'california']
  },
  {
    id: 'hist-2',
    title: 'Coffee Roasting Morning Ritual [Short]',
    type: 'short',
    mediaUrl: 'https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?w=800&auto=format&fit=crop&q=80',
    thumbnailUrl: 'https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?w=600&auto=format&fit=crop&q=80',
    uploadDate: 'Aug 29, 2026',
    views: 94200,
    likes: 8310,
    duration: '00:45',
    fileSize: '14.8 MB',
    tags: ['coffee', 'morning', 'shorts', 'lifestyle']
  },
  {
    id: 'hist-3',
    title: 'Architectural Minimalist Loft [Photo Shoot]',
    type: 'image',
    mediaUrl: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&auto=format&fit=crop&q=80',
    thumbnailUrl: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&auto=format&fit=crop&q=80',
    uploadDate: 'Aug 25, 2026',
    views: 12600,
    likes: 980,
    fileSize: '5.4 MB',
    tags: ['architecture', 'design', 'minimalism', 'photo']
  },
  {
    id: 'hist-4',
    title: 'Neon Tokyo Alleyway Long Exposure',
    type: 'image',
    mediaUrl: 'https://images.unsplash.com/photo-1503899036084-c55cdd92da26?w=800&auto=format&fit=crop&q=80',
    thumbnailUrl: 'https://images.unsplash.com/photo-1503899036084-c55cdd92da26?w=600&auto=format&fit=crop&q=80',
    uploadDate: 'Aug 20, 2026',
    views: 31400,
    likes: 2450,
    fileSize: '7.8 MB',
    tags: ['tokyo', 'neon', 'night', 'cyberpunk']
  },
  {
    id: 'hist-5',
    title: 'Studio Lighting Setup Behind The Scenes [Long]',
    type: 'video',
    mediaUrl: 'https://images.unsplash.com/photo-1581291518857-4e27b48ff24e?w=800&auto=format&fit=crop&q=80',
    thumbnailUrl: 'https://images.unsplash.com/photo-1581291518857-4e27b48ff24e?w=600&auto=format&fit=crop&q=80',
    uploadDate: 'Aug 14, 2026',
    views: 45800,
    likes: 3100,
    duration: '18:40',
    fileSize: '185.0 MB',
    tags: ['studio', 'tutorial', 'lighting', 'camera']
  }
];
